import styled from "styled-components";
import { Flex } from "../Grid";

const MagazineBlockItemDetails = styled(Flex)`
  max-height: 1.5em;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  -webkit-box-pack: right;
  overflow: hidden;
`;

MagazineBlockItemDetails.defaultProps = {
  my: 1,
  alignItems: "flex-start",
  flexWrap: "wrap",
  color: "headlinesSecondary",
};

export { MagazineBlockItemDetails };
